module.exports = __webpack_public_path__ + "static/media/gr.334890b6.svg";